/**
 * CER-77 — Approve for Portal labelling-gate UX (keeps CER-69 hard gate).
 *
 * When approve-upload returns 409 labelling-unconfirmed, Admin shows a Show-me
 * jump to the Switchboard labelling select instead of a bare red error. The
 * QA override banner must say force does not bypass that confirmation.
 */

/** DOM id of the Switchboard labelling <select> in ReportHardwareEditor. */
export const SWITCHBOARD_LABELLING_SELECT_ID = 'edit-switchboard-labelling';

/** Anchor for the Hardware section inside the edit panel. */
export const EDIT_HARDWARE_ANCHOR_ID = 'edit-hardware';

export const LABELLING_UNCONFIRMED_BANNER =
  'Confirm switchboard and meter box labelling (AS/NZS 5139:2019) on Hardware → Switchboard before approving for the portal.';

/**
 * Shown on the QA "Approve for Portal anyway" banner so operators know force
 * still cannot skip the CER-69 labelling confirmation.
 */
export const QA_OVERRIDE_LABELLING_NOTE =
  'Approving anyway does not bypass switchboard labelling confirmation — confirm labelling on Hardware → Switchboard first if it is still unset.';

export const LABELLING_CHIP_LABEL = 'Labelling: not confirmed';

/** Focus target after opening Edit and scrolling to Hardware. */
export function focusSwitchboardLabellingSelect(
  doc: Pick<Document, 'getElementById'> = document,
): boolean {
  const el = doc.getElementById(SWITCHBOARD_LABELLING_SELECT_ID);
  if (!el) return false;
  el.focus();
  el.classList.remove('jump-flash');
  // Reflow so re-adding the class restarts the flash animation.
  void el.offsetWidth;
  el.classList.add('jump-flash');
  return true;
}
